/**
 * Адреса приложения. Часть из них зашита в письма и редиректы API — `/login`,
 * `/login/second-factor`, `/verify-email`, `/reset-password`, `/confirm-email`,
 * `/invitations/accept`, `/profile` (identity-mail.service, invitation-mail.service,
 * google.controller): их меняют только вместе с сервером.
 */
export const paths = {
  root: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  workspace: (workspaceId: string) => `/w/${workspaceId}`,
  diagram: (workspaceId: string, diagramId: string) => `/w/${workspaceId}/d/${diagramId}`,
  profile: '/settings/profile',
  security: '/settings/security',
  workspaces: '/settings/workspaces',
  workspaceSettings: (workspaceId: string, section?: 'members' | 'invitations' | 'audit') =>
    `/w/${workspaceId}/settings${section === undefined ? '' : `/${section}`}`,
} as const;
